import React from "react";
import { StyledButton } from "../../styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { useTagDetails } from "../../context";

const ActionButton = () => {
  const {
    submitting,
    disabled,
    onSubmitTag,
    onSubmitTagTranslation,
  } = useTagDetails();
  const { allowed: hasWriteAccess } = useRolePermission("tags:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission("tags:translations:write");

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <StyledButton
        title="Save"
        size="small"
        disabled={disabled}
        onClick={onSubmitTagTranslation}
        loading={submitting}
      />
    );
  }

  return (
    <StyledButton
      title="Save"
      size="small"
      disabled={disabled}
      onClick={onSubmitTag}
      loading={submitting}
    />
  );
};

export default ActionButton;